import { render, staticRenderFns } from "./upload-file-v2.vue?vue&type=template&id=3cd5f6a2&scoped=true&"
import script from "./upload-file-v2.vue?vue&type=script&lang=js&"
export * from "./upload-file-v2.vue?vue&type=script&lang=js&"
import style0 from "./upload-file-v2.vue?vue&type=style&index=0&id=3cd5f6a2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd5f6a2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cd5f6a2')) {
      api.createRecord('3cd5f6a2', component.options)
    } else {
      api.reload('3cd5f6a2', component.options)
    }
    module.hot.accept("./upload-file-v2.vue?vue&type=template&id=3cd5f6a2&scoped=true&", function () {
      api.rerender('3cd5f6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/upload-file-v2.vue"
export default component.exports